import { render } from "./Template3.vue?vue&type=template&id=3623b91b&scoped=true"
import script from "./Template3.vue?vue&type=script&lang=ts"
export * from "./Template3.vue?vue&type=script&lang=ts"

import "./Template3.vue?vue&type=style&index=0&id=3623b91b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3623b91b"

export default script